import { orchestrator } from 'satcheljs';
import setErrorDialogState from '../mutators/setErrorDialogState';
import { connectedAccountInErrorState, OWAConnectedAccountState } from 'owa-accounts-store';
import { CalendarAccountErrorDialogState } from '../schema/CalendarAccountErrorDialogState';

orchestrator(connectedAccountInErrorState, ({ accountState }) => {
    const errorState =
        accountState == OWAConnectedAccountState.TransientTokenError ||
        accountState == OWAConnectedAccountState.UnknownTokenError
            ? CalendarAccountErrorDialogState.AccountLoadTokenError
            : CalendarAccountErrorDialogState.AccountLoadNonTokenError;
    setErrorDialogState(false, errorState);
});
